module.exports = new __parcel__URL__("style.66dbc1da.css").toString();